import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'chronology', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'chronology'),
				action: ({ model, t }) => {
					const { chro_title } = model;
					Utils.openLink({
						pathname: '/chronology/add',
						state: {
							model: { ...model, chro_title: chro_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(
						showAddNotesDialog({ model: { note_table: 'chronology', note_table_uid: model.chro_uid } })
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_maac_uid: model.chro_maac_uid,
								oppo_dems_uid: model.chro_dems_uid,
								oppo_parent_oppo_uid: model.chro_oppo_uid,
								oppo_cntr_uid: model.chro_cntr_uid,
								oppo_ords_uid: model.chro_ords_uid,
								oppo_proj_uid: model.chro_proj_uid,
								oppo_acti_uid: model.chro_acti_uid,
								oppo_chro_uid: model.chro_uid,
								oppo_wore_uid: model.chro_wore_uid,
								oppo_tick_uid: model.chro_tick_uid,
								oppo_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_maac_uid: model.chro_maac_uid,
								cntr_dems_uid: model.chro_dems_uid,
								cntr_oppo_uid: model.chro_oppo_uid,
								cntr_parent_cntr_uid: model.chro_cntr_uid,
								cntr_ords_uid: model.chro_ords_uid,
								cntr_proj_uid: model.chro_proj_uid,
								cntr_acti_uid: model.chro_acti_uid,
								cntr_wore_uid: model.chro_wore_uid,
								cntr_chro_uid: model.chro_uid,
								cntr_tick_uid: model.chro_tick_uid,
								cntr_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_maac_uid: model.chro_maac_uid,
								proj_dems_uid: model.chro_dems_uid,
								proj_oppo_uid: model.chro_oppo_uid,
								proj_cntr_uid: model.chro_cntr_uid,
								proj_ords_uid: model.chro_ords_uid,
								proj_parent_proj_uid: model.chro_proj_uid,
								proj_acti_uid: model.chro_acti_uid,
								proj_wore_uid: model.chro_wore_uid,
								proj_chro_uid: model.chro_uid,
								proj_tick_uid: model.chro_tick_uid,
								proj_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_maac_uid: model.chro_maac_uid,
								acti_dems_uid: model.chro_dems_uid,
								acti_oppo_uid: model.chro_oppo_uid,
								acti_cntr_uid: model.chro_cntr_uid,
								acti_ords_uid: model.chro_ords_uid,
								acti_proj_uid: model.chro_proj_uid,
								acti_parent_acti_uid: model.chro_acti_uid,
								acti_wore_uid: model.chro_wore_uid,
								acti_chro_uid: model.chro_uid,
								acti_tick_uid: model.chro_tick_uid,
								acti_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: {
								wore_maac_uid: model.chro_maac_uid,
								wore_dems_uid: model.chro_dems_uid,
								wore_oppo_uid: model.chro_oppo_uid,
								wore_cntr_uid: model.chro_cntr_uid,
								wore_ords_uid: model.chro_ords_uid,
								wore_proj_uid: model.chro_proj_uid,
								wore_acti_uid: model.chro_acti_uid,
								wore_parent_wore_uid: model.chro_wore_uid,
								wore_chro_uid: model.chro_uid,
								wore_tick_uid: model.chro_tick_uid,
								wore_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_maac_uid: model.chro_maac_uid,
								chro_dems_uid: model.chro_dems_uid,
								chro_oppo_uid: model.chro_oppo_uid,
								chro_cntr_uid: model.chro_cntr_uid,
								chro_ords_uid: model.chro_ords_uid,
								chro_proj_uid: model.chro_proj_uid,
								chro_acti_uid: model.chro_acti_uid,
								chro_parent_chro_uid: model.chro_uid,
								chro_wore_uid: model.chro_wore_uid,
								chro_tick_uid: model.chro_tick_uid,
								chro_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: {
								tick_maac_uid: model.chro_maac_uid,
								tick_dems_uid: model.chro_dems_uid,
								tick_oppo_uid: model.chro_oppo_uid,
								tick_cntr_uid: model.chro_cntr_uid,
								tick_ords_uid: model.chro_ords_uid,
								tick_proj_uid: model.chro_proj_uid,
								tick_acti_uid: model.chro_acti_uid,
								tick_wore_uid: model.chro_wore_uid,
								tick_chro_uid: model.chro_uid,
								tick_parent_tick_uid: model.chro_tick_uid,
								tick_comp_uid: model.chro_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'chronology'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'chronology',
							id: model.chro_uid,
							title: model.chro_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'chronology'),
				action: () => Utils.openLink({ pathname: '/chronology/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'chronology'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'chronology'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'chronology',
							id: model.chro_uid,
							title: model.chro_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'chronology'),
				action: ({ switchEdit }) => switchEdit()
			}
		]
	}
};

export default buttons;
